<style lang="scss">
.workshopHourOuput::-webkit-scrollbar {
  display: none;
}
</style>
<style lang="scss" scoped>
.weier-prodcution-monitor-border {

  border: 1px solid;
  border-image: url("../../../../../../assets/img/web/weier/production/xiankuang2.png") 10 stretch;
}
</style>
<template>
  <div class="workshopHourOuput" ref="container" style="overflow: auto;height: 100%;position: relative;">
    <div ref="titleBar" class="titleBar" style="display: flex;align-items:center ;padding-bottom: 0px;box-sizing: border-box;">
      <img style="width: auto;height: 42px;" src="../../../../../../assets/img/web/weier/production/mxscl.png" />
    </div>
    <div class="weier-prodcution-monitor-border" style="flex: 1;display: flex;flex-direction: column;justify-content: space-between;">

      <div id="WeierhourOutputChart" :style="{ height: chartHeight + 'px' }"></div>
    </div>

  </div>
</template>
<script type="text/javascript">
export default {
  name: "web_customize_weier_monitor_production_hour_output",
  components: {},
  props: {
    datas: {
      type: Object,
      default: () => {
        return {};
      },

    },
  },
  data() {
    return {
      timmer: null,
      chart: null,
      options: null,
      chartHeight: 0,
      t: [],
      v: [],
    };
  },
  watch: {
    "datas": {
      handler(newValue, oldValue) {
        console.log(newValue, oldValue, this.datas)
        if (this.utils.isEqual(newValue, oldValue)) {
          return;
        }
        this.makeData();
      },
      immediate: true,
      deep: true
    },
  },

  created() {

  },
  activated() {
    this.resize();
  },
  mounted() {
    setTimeout(() => {
      this.initChart();
      this.resize();
    }, 700);
    this.resize();
    this.utils.event_hub.$on("RESIZE", () => {
      this.resize();
    });
  },
  destroyed() {
    clearInterval(this.timmer);
  },
  methods: {
    async makeData() {

      this.t = this.datas.list.map((item) => {
        return item.t;
      });

      this.v = this.datas.list.map((item) => {
        return item.v;
      });

      this.chartHeight = this.$refs.container.offsetHeight - this.$refs.titleBar.offsetHeight - 2;
      if (!this.chart) {
        setTimeout(() => {
          this.initChart();
        }, 100);
      } else {
        if (this.option.xAxis.length == undefined) {
          this.option.xAxis.data = this.t;
        } else {
          this.option.xAxis[0].data = this.t;
        }
        this.option.series[0].data = this.v;
        this.chart.setOption(this.option);
      }
    },
    resize() {
      //因为内容高度也是延迟计算的，这里必须设置延迟比外面Index更延迟
      setTimeout(() => {
        if (!this.$refs.titleBar) {
          return;
        }
        this.chartHeight = this.$refs.container.offsetHeight - this.$refs.titleBar.offsetHeight - 2;
        if (!this.chart) {
          return;
        }
        this.chart.getDom().style.height = this.chartHeight + "px";
        this.chart.resize();
      }, 800);
    },
    initChart() {
      this.option = {
        backgroundColor: null,
        tooltip: {
          trigger: "axis",
          axisPointer: {
            // 坐标轴指示器，坐标轴触发有效
            type: "shadow", // 默认为直线，可选为：'line' | 'shadow'
          },
        },
        grid: {
          left: "10",
          right: "10",
          bottom: "10",
          top: "20",
          containLabel: true,
        },

        xAxis: {
          show: true,
          type: "category",
          axisLabel: {
            textStyle: {
              fontSize: 12,
              color: "#C0C4CC",
            },
            interval: "auto",
          },
          axisTick: {
            show: false,
          },
          data: this.t,
        },
        yAxis: [
          {
            show: true,
            type: "value",
            min: 0,

            axisTick: {
              show: false,
            },
            axisLabel: {
              textStyle: {
                fontSize: 12,
                color: "#C0C4CC",
              },
            },
            splitLine: {
              show: true,
              lineStyle: {
                type: "dashed",
                color: "#606672",
              },
            },
          },
        ],
        series: [
          {
            name: "产量",
            type: "bar",
            barWidth: "8px",
            itemStyle: {
              normal: {
                color: new this.echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  {
                    offset: 0,
                    color: "#6FE5FF",
                  },
                  {
                    offset: 1,
                    color: "#1C70C6",
                  },
                ]),
                barBorderRadius: 4,
              },
            },

            data: this.v,
          },
        ],
      };
      var chartDom = document.getElementById("WeierhourOutputChart");
      this.chart = this.echarts.init(chartDom);
      this.option && this.chart.setOption(this.option);
    },
  },
};
</script>
